import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ActFormData {
  // Add all the fields from the act form
  [key: string]: any;
}

export interface ValueInDisputeFormData {
  // Add all the fields from the value in dispute form
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class FormDataService {
  private actFormDataSubject = new BehaviorSubject<ActFormData | null>(null);
  private valueInDisputeFormDataSubject = new BehaviorSubject<ValueInDisputeFormData | null>(null);

  constructor() { }

  // Act Form Data Methods
  setActFormData(data: ActFormData): void {
    this.actFormDataSubject.next(data);
  }

  getActFormData(): Observable<ActFormData | null> {
    return this.actFormDataSubject.asObservable();
  }

  getActFormDataSnapshot(): ActFormData | null {
    return this.actFormDataSubject.value;
  }

  // Value in Dispute Form Data Methods
  setValueInDisputeFormData(data: ValueInDisputeFormData): void {
    this.valueInDisputeFormDataSubject.next(data);
  }

  getValueInDisputeFormData(): Observable<ValueInDisputeFormData | null> {
    return this.valueInDisputeFormDataSubject.asObservable();
  }

  getValueInDisputeFormDataSnapshot(): ValueInDisputeFormData | null {
    return this.valueInDisputeFormDataSubject.value;
  }

  // Clear all data
  clearAllData(): void {
    this.actFormDataSubject.next(null);
    this.valueInDisputeFormDataSubject.next(null);
  }
} 